import(/* webpackMode: "eager" */ "/app/apps/user/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/user/components/common/OfflineIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/user/components/CookieConsent/CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/user/components/table/SomethingWentWrong.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/user/providers/LoggedInProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/user/providers/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
